import { GridOverlay } from "./components/grid-overlay.js";
import { Utilities } from "./utilities/utilities.js";
import { Modal } from "./components/modal.js";
import { HomePage } from "./pages/home.js";
import { WindowMetrics } from "./utilities/window-metrics.js";
import { Header } from "./components/header.js";
import { AhusOverview } from "./pages/ahus-overview.js";
import { DiagnosingAhus } from "./pages/diagnosing-ahus.js";
import { ComplementSystem } from "./pages/complement-system.js";
import { Pathophysiology } from "./pages/pathophysiology.js";
import { RecourcesHcp } from "./pages/resources-hcp.js";
import { AlexionConnectBanner } from "./components/alexion-connect.js";

import { StyleGuide } from "./pages/styleguide.js";

export class AhusHcpSource {
    constructor(parameters) {
        var t = this;

        // Setup grid overlay
        GridOverlay.initialize();

        // Perform page-specific setup
        switch (document.body.id) {
            case "home":
                new HomePage(parameters);
                break;

            case "ahus-overview":
                new AhusOverview(parameters);
                break;

            case "diagnosing-ahus":
                new DiagnosingAhus(parameters);
                break;

            case "complement-system-and-ahus":
                new ComplementSystem(parameters);
                break;

            case "pathophysiology":
                new Pathophysiology(parameters);
                break;

            case "resources-hcp":
                new RecourcesHcp(parameters);
                break;

            case "styleguide":
                new StyleGuide(parameters);
                break;
            default:
                break;
        }
        t.header = new Header();
        // initialize sticky header 
        Header.initialize(
            Header.stickyModes.alwaysVisible,
            Header.mobileMenuModes.collapsable,
            Header.desktopMenuModes.dropdown);

        // references accordion in footer
        var referencesContainer = document.querySelector('#references'),
            referencesControl = document.querySelector('#references p'),
            referencesContent = document.querySelector('#references ol');

        referencesControl.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var timeline = new TimelineMax();

            if (referencesContainer.classList.contains('open')) {
                // Closing
                references.classList.remove('open');

                timeline.add("start");

                timeline.fromTo(
                    referencesContainer,
                    1.0,
                    {
                        height: referencesControl.clientHeight + referencesContent.clientHeight
                    },
                    {
                        ease: Power2.easeOut,
                        height: referencesControl.clientHeight
                    },
                    0);

                timeline.fromTo(
                    referencesContent,
                    0.5,
                    {
                        opacity: 1
                    },
                    {
                        ease: Power2.easeOut,
                        opacity: 0
                    },
                    0);

                timeline.add(function () {
                    // Remove the hard-coded height once the animation is finished
                    Utilities.resetStyles(referencesContainer);

                    // And re-hide the content
                    Utilities.resetStyles(referencesContent);
                });

                timeline.add("end");

                // Scroll upward if the collapsed references makes the window shorter
                let maxScrollPosition = document.body.clientHeight - referencesContent.clientHeight - window.innerHeight;
                if (window.pageYOffset > maxScrollPosition)
                    Utilities.scrollWindowToPosition(maxScrollPosition);
            } else {
                // Opening
                referencesContainer.classList.add("open");
                referencesContent.style.display = 'block';

                timeline.add("start");

                timeline.fromTo(
                    referencesContainer,
                    1.0,
                    {
                        height: referencesControl.clientHeight
                    },
                    {
                        ease: Power2.easeOut,
                        height: referencesControl.clientHeight + referencesContent.clientHeight
                    },
                    0);

                timeline.fromTo(
                    referencesContent,
                    0.5,
                    {
                        opacity: 0
                    },
                    {
                        ease: Power2.easeOut,
                        opacity: 1
                    },
                    0);

                timeline.add(function () {
                    // Remove the hard-coded height once the animation is finished;
                    // the <ol> will determine the height at this point
                    Utilities.resetStyles(referencesContainer);
                });

                timeline.add("end");

                // Scroll to the references
                let scrollPosition = calculateTargetScrollPosition(referencesContainer);
                Utilities.scrollWindowToPosition(scrollPosition);
            }
        });

        window.addEventListener('resize', function () {
            // Close the mobile menu if it's open
            if (WindowMetrics.isMobile()) {
                if (t.header.isOpen)
                    t.header.close();
            }
        });

        var calculateTargetScrollPosition = function (targetElement) {
            let targetScrollPosition = targetElement.getBoundingClientRect().top;

            // Incorporate current scroll offset
            targetScrollPosition += window.pageYOffset;

            // Check if we're in mobile
            //if (WindowMetrics.isMobile()) {
            //    targetScrollPosition -= document.querySelector('header').clientHeight;
            //} else {
            targetScrollPosition -= document.querySelector('header').clientHeight;
            //}

            return targetScrollPosition;
        };
        // jumplinks 
        var jumplinks = document.querySelectorAll('#jumplinks li a'),
            hdr = document.querySelector('header');

        for (var j = 0; j < jumplinks.length; j++) {
            let jumplink = jumplinks[j];

            jumplink.addEventListener('click', function (event) {

                event.preventDefault();
                event.stopPropagation();

                var id = this.getAttribute('href'),
                    loc = id.replace(/#/, ''),
                    targetElement = document.getElementById(loc);

                let targetScrollPosition = calculateTargetScrollPosition(targetElement);
                Utilities.scrollWindowToPosition(targetScrollPosition);

                // Close the mobile menu if it's open
                if (WindowMetrics.isMobile()) {
                    if (t.header.isOpen)
                        t.header.close();
                }

            });

        }
        // end of page callouts linkage 
        var eopCallouts = document.querySelectorAll('#eop-callouts > div > .flex-row > div');
        if (typeof (eopCallouts) != 'undefined' && eopCallouts != null) {
            for (var c = 0; c < eopCallouts.length; c++) {
                let callout = eopCallouts[c];
                callout.addEventListener('click', function (event) {
                    event.preventDefault();
                    event.stopPropagation();

                    var ctaEl = this.querySelector('a'),
                        myHref = ctaEl.getAttribute('href');

                    if (ctaEl.hasAttribute('target')) {
                        window.open(myHref);
                    }
                    else {
                        document.location.href = myHref;
                    };
                    //console.table([["event", "gtm.click"], ["gtm.elementUrl", myHref], ["Class", this.parentNode.parentNode.parentNode.getAttribute('id') ] ]);

                    // IF WE ADD GTM, USE THIS TO SEND DATA TO 
                    // GTM ON CLICKS THAT AREN'T ACTUAL <a> TAGS
                    //dataLayer.push({
                    //    'event': 'gtm.click',
                    //    'gtm.elementClasses': this.parentNode.parentNode.parentNode.getAttribute('id'),
                    //    'gtm.elementUrl': myHref
                    //})

                });
            }
        }

        // leaving site modal
        var
            modalTemplate = `
<form class="modal-template">
    <section>
        <p>You are now leaving the aHUSSource.com website.</p>
        <p>Alexion is not responsible for content included on third-party websites. Do you want to proceed?</p>
        
        <input type="button" class="ok-button cta primary" value=" PROCEED" />
        <input type="button" class="cancel-button cta secondary" value="STAY" />
    </section>
</form>`;

        let externalLinks = document.querySelectorAll('a[target="_blank"]:not(.internal-link)');
        for (let i = 0; i < externalLinks.length; i++) {
            let externalLink = externalLinks[i],
                link = externalLink.getAttribute('href');
            //if (link == null)
            //    continue;

            externalLink.addEventListener('click', function (event) {

                event.preventDefault();
                event.stopPropagation();

                if (this.getAttribute("target") == "_blank") {
                    Modal.show(
                        modalTemplate,
                        'leaving-site',
                        Modal.presentationTypes.fade,
                        Modal.presentationTypes.fade,
                        false,
                        {
                            preShow: function () {
                                let modal = this;
                                modal.container.querySelector('.ok-button').addEventListener('click', function () {
                                    // Close the modal with a confirmation animation
                                    window.open(link);
                                    modal.close(false, Modal.presentationTypes.fade);
                                });

                                modal.container.querySelector('.cancel-button').addEventListener('click', function () {
                                    // Close the modal with a dismissal animation
                                    modal.close(false, Modal.presentationTypes.fade);
                                });

                                // add back close event listener on backdrop
                                modal.backdrop.addEventListener('click', function (event) {
                                    event.preventDefault();
                                    event.stopPropagation();

                                    modal.close(false, Modal.presentationTypes.fade);
                                });
                            }
                        },
                        event);
                }
                else {
                    window.location.href = link;
                    return false;
                }
            });
        }

        // Setup Alexion Connect banner
        //new AlexionConnectBanner();

        // Welcome interstitial 
        var
            welcomeTemplate = `
            <form class="modal-template">
                <section>
                    <p>The information contained on this site is intended for healthcare professionals in the United States only.<br>
                    It is not intended for the general public.</p>
        
                    <input type="button" class="ok-button cta primary" value="I AM a US healthcare professional" />
                    <input type="button" class="cancel-button cta secondary" value="I am NOT a US healthcare professional" />
                </section>
            </form>`,
            welcomeKey = 'entering-site';

        document.addEventListener("DOMContentLoaded", function (e) {
            // check if visitor has confirmed HCP cookie
            if (localStorage.getItem(welcomeKey) !== 'hcp') {
                Modal.show(
                    welcomeTemplate,
                    welcomeKey,
                    Modal.presentationTypes.fade,
                    Modal.presentationTypes.fade,
                    false,
                    {
                        preShow: function () {
                            let modal = this;
                            modal.container.querySelector('.ok-button').addEventListener('click', function () {
                                // Close the modal with a confirmation animation
                                modal.close(false, Modal.presentationTypes.fade);
                                // set HCP cookie so they don't see modal again
                                localStorage.setItem(welcomeKey, 'hcp');
                            });

                            modal.container.querySelector('.cancel-button').addEventListener('click', function () {
                                // go to patient site
                                window.location.assign('http://ahussource.com/');
                            });
                        }
                    },
                    event);
            }
            

        });

    }
}

window.AhusHcpSource = AhusHcpSource;
export default AhusHcpSource;